import { render, staticRenderFns } from "./DeleteAdmin.vue?vue&type=template&id=510a24f1&scoped=true"
import script from "./DeleteAdmin.vue?vue&type=script&lang=js"
export * from "./DeleteAdmin.vue?vue&type=script&lang=js"
import style0 from "./DeleteAdmin.vue?vue&type=style&index=0&id=510a24f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510a24f1",
  null
  
)

export default component.exports